import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SCALE, VALIDATION_STATES } from '../../utils/constants';
import useFormValidation from './useFormValidation';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default function Form(props) {
  const {
    children,
    id,
    allowNativeSubmit,
    onSubmit,
    validators,
    ...remainingProps
  } = props;
  const {
    validationState: valid,
    message,
    formProps
  } = useFormValidation({
    validators,
    onSubmit,
    allowNativeSubmit
  });
  function processChildren(child, props) {
    if (typeof child !== 'function') {
      return /*#__PURE__*/React.cloneElement(child, {
        key: props.key,
        ...props
      });
    } else {
      const renderedChild = child(valid, {
        ...props,
        message
      });
      if (renderedChild) {
        return /*#__PURE__*/React.cloneElement(renderedChild, {
          key: props.key,
          message: message
        });
      } else {
        return null;
      }
    }
  }
  let processedChildren = children;

  //React.Children does not enumerate functional components.
  if (children) {
    if (children.map) {
      processedChildren = children.map((child, i) => {
        var _child$props, _child$props2;
        const key = child.key || ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id) || ((_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.name) || i;
        return processChildren(child, {
          key,
          ...remainingProps
        });
      });
    } else {
      processedChildren = processChildren(children, remainingProps);
    }
  }
  return /*#__PURE__*/React.createElement("form", _extends({
    id: id
  }, remainingProps, formProps), processedChildren);
}
Form.enums = {
  validationStates: VALIDATION_STATES,
  scale: SCALE
};